<template>
  <v-layout row wrap>
    <v-flex xs4 v-if="dataset.dataset_id">
      <LogoYourWay>
      </LogoYourWay>
    </v-flex>
    <v-flex xs8 v-if="dataset.dataset_id">
      <blockquote 
          v-if="!editMode" 
          class="display-1 mt-1"
          data-cy="dataset-name-display"
      >
          {{ dataset.dataset_name }}
      </blockquote>
      <v-textarea 
          v-else
          box
          label="Dataset Name"
          v-model="datasetName"
          :error-messages="textFieldErrors($v.datasetName)"
          :hint="`${datasetName.length}/200 Characters`"
          required
          @input="$v.datasetName.$touch()"
          @blur="$v.datasetName.$touch()"
          data-cy="dataset-name-textarea"
      >
      </v-textarea>
      <v-layout row nowrap>
        <v-flex xs12 v-if="fillBar != -1">
          <v-progress-linear 
          :value="fillBar" 
          color="green lighten-1" 
          background-color="red lighten-3"
          height="10"
          >
          </v-progress-linear>
          <b>{{ parseInt(fillBarPercent) }}% complete</b><br/><br/>
        </v-flex>
        <v-flex xs12 v-else>
          <v-progress-linear 
          :value="100" 
          color="grey lighten-1" 
          height="10"
          >
          </v-progress-linear>
          <b>No milestones registered yet</b><br/><br/>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import LogoYourWay from './LogoYourWay.vue'
import { mapMutations, mapGetters } from 'vuex'
import { required, maxLength } from 'vuelidate/lib/validators'
import { validationMixin } from '../validators.js'

export default {
  mixins: [validationMixin],
  validations: {
    datasetName: {
      required,
      maxLength: maxLength(200)
    }
  },
  components: {
    LogoYourWay
  },
  props: {
    editMode: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.$watch('$v', (newVal, oldVal) => {
        this.setTopFieldsInvalid(newVal.$invalid)
      }, { deep: true })
  },
  data () {
    return {
      fillBarNum: 0
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentDataset',
      'getDatasetEdits',
      'getPresentMode'
    ]),
    dataset () {
      return this.getCurrentDataset
    },
    fillBar () {
      if (this.dataset.dataset_milestone.length === 0) {
        return -1
      } else {
        let percent = 0
        for (let i = 0; i < this.dataset.dataset_milestone.length; i++) {
          percent += this.dataset.dataset_milestone[i].milestone_percent_complete
        }
        return this.fillBarNum + (percent / this.dataset.dataset_milestone.length)
      }
    },
    fillBarPercent () {
      let num = this.fillBar
      return num.toFixed(0)
    },
    datasetName: {
      get () {
        return this.$store.getters.getDatasetEdits.dataset_name
      },
      set (val) {
        this.setDatasetEdit({
          key: 'dataset_name',
          value: val
        })
      }
    }
  },
  methods: {
    ...mapMutations([
      'setDatasetEdit',
      'setTopFieldsInvalid'
    ])
  }
}
</script>